import {__} from "./__";

export const getAiTranslateCategoryInputs = () => {
    return {
        category_name: __('Názov kategórie'),
        category_short_description: __('Krátky popis kategórie'),
        category_description: __('Dlhý popis kategórie'),
        category_seo_title: __('SEO (meta) názov kategórie'),
        category_seo_description: __('SEO (meta) popis kategórie'),
    };
};
